import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import {LJStyleTp} from "@/js/constants";

// import lifeDetection from '@/pages/systemManage/lifeDetection'  //生命雷达探测

Vue.use(Router)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/lisVideo',
      name: 'lisVideo',
      component: () => import('@/pages/lisVideo')
    },
    {
      path: '/channelVideo',
      name: 'channelVideo',
      component: () => import('@/pages/channelVideo')
    },
    {
      path: '/recordSheet',
      name: 'RecordSheet',
      component: () => import('@/pages/recordSheet')
    },
    // h5调用天气组件
    {
      path: '/weatherH5',
      name: 'weatherH5',
      component: () => import('@/pages/waterlogging/components/weather.vue')
    },
    {
      path: '/homeMenu',
      name: 'homeMenu',
      component: async () => import('@/pages/fireSide/homeMenu'),
      children: [
        {
          path: '/homePage',
          name: 'HomePage',
          component: async () => import('@/pages/fireSide/homePage')
        }
      ]
    },
     // 楼宇警情
    {
      path: '/buildingAlarm',
      name: 'buildingAlarm',
      component: async () => import('@/pages/index/BuildingAlarm.vue')
    },
    {
      path: '/intellManageCockpit',
      name: 'intellManageCockpit',
      component: async () => import('@/pages/index/IntellManageCockpit')
    },
    {
      path: '/demo',
      name: 'demo',
      component: async () => import('@/pages/baseCall/demo')
    },
    {
      path: '/indexStreet',
      name: 'IndexStreet',
      component: async () => import('@/pages/index/IndexStreet')
    },
    {
      path: '/detachment',
      name: 'Detachment',
      component: async () => import('@/pages/index/Detachment')
    },
    {
      path: '/street',
      name: 'Street',
      component: async () => import('@/pages/index/Street')
    },
    {
      path: '/squadron',
      name: 'Squadron',
      component: async () => import('@/pages/index/Squadron')
    },
    {
      path: '/',
      name: 'Login',
      component: async () => import('@/pages/login/Login')
    },
    {
      path: '/channelLogin',
      name: 'ChannelLogin',
      component: async () => import('@/pages/login/ChannelLogin.vue')
    },
    {
      path: '/silentLogin',
      name: 'SilentLogin',
      component: async () => import('@/pages/login/SilentLogin.vue')
    },
    {
      path: '/menuHome',
      name: 'menuHome',
      component: async () => import('@/pages/login/menuHome')
    },
    // {
    //   path: '/index',
    //   name: 'Index',
    //   component: Index
    // },
    {
      path: '/home',
      name: 'Home',
      component: async () => import('@/pages/index/Home')
    },
    {
      path: '/homeWz',
      name: 'HomeOther',
      component: async () => import('@/pages/index/HomeOther')
    },
    {
      path: '/HomeConcise',
      name: 'HomeConcise',
      component: async () => import('@/pages/index/HomeConcise')
    },
    {
      path: '/container',
      name: 'container',
      component: async () => import('@/pages/container/index.vue'),
      children: [
        {
          path: '/wisdomIndex',
          name: 'wisdomIndex',
          component: async () => import('@/pages/wisdomIndex/index.vue')
        },
        // 朝外街道定制首页
        {
          path: '/home-channel',
          name: 'home-channel',
          component: async () => import('@/pages/index/homeChannel/index.vue')
        },
        {
          path: '/home-ljfl',
          name: 'home-ljfl',
          component: async () => import('@/pages/index/homeChannel/ljflIndex.vue')
        },
        {
          path: '/securityDoor',
          name: 'securityDoor',
          component: async () => import('@/pages/pileThing/securityDoor')
        },
        {
          path: '/monitorDangers',
          name: 'monitorDangers',
          component: async () => import('@/pages/monitorDangers/listMonitorDangers')
        },
        {
          path: '/ljsb',
          name: 'ljsb',
          component: async () => import('@/pages/ljsb/ljsb')
        },
        {
          path: '/pileThing',
          name: 'pileThing',
          component: async () => import('@/pages/pileThing/pileThing')
        },
        {
          path: '/lddw',
          name: 'lddw',
          component: async () => import('@/pages/lddw/index.vue')
        },
        {
          path: '/fireEngine',
          name: 'fireEngine',
          component: async () => import('@/pages/fireEngine/fireEngine')
        },
        {
          path: '/pinkeyeDangers',
          name: 'pinkeyeDangers',
          component: async () => import('@/pages/pinkeyeDangers/pinkeyeDangers')
        },
        {
          path: '/ryxc',
          name: 'ryxc',
          component: async () => import('@/pages/handNewspaperDangers/ryxc')
        },
        {
          path: '/fireWatch',
          name: 'fireWatch',
          component: async () => import('@/pages/handNewspaperDangers/fireWatch')
        },
        {
          path: '/dhlrList',
          name: 'dhlrList',
          component: async () => import('@/pages/dhlr/list')
        },
        {
          path: '/dhlr',
          name: 'dhlrIndex',
          component: async () => import('@/pages/dhlr/index')
        },
        {
          path: '/waterDangers',
          name: 'waterDangers',
          component: async () => import('@/pages/waterDangers/listWaterDangers')
        },
        {
          path: '/jcfx',
          name: 'jcfx',
          component: async () => import('@/pages/jcfx/index.vue')
        },
        {
          path: '/ryzs',
          name: 'ryzsIndex',
          component: async () => import('@/pages/ryzs/index-new.vue')
        },
        {
          path: '/ryzs-new',
          name: 'ryzsNew',
          component: async () => import('@/pages/ryzs/index-new.vue')
        },
        {
          path: '/flfx',
          name: 'flfxIndex',
          // component: async () => import('@/pages/wlwt/index')
          // component: async () => import('@/pages/flfx/index')
          component: async () => import('@/pages/gzkh/kh-analysis.vue')
        },
        {
          path: '/ddcp',
          name: 'ddcpIndex',
          component: async () => import('@/pages/ddcp/index')
        },
        {
          path: '/ddcpList',
          name: 'ddcpList',
          component: async () => import('@/pages/ddcp/List')
        },
        {
          path: '/mhq',
          name: 'mhqIndex',
          component: async () => import('@/pages/mhq-n/index.vue')
        },
        {
          path: '/mhqList',
          name: 'mhqList',
          component: async () => import('@/pages/mhq/list')
        },
        {
          path: '/water',
          name: 'water',
          component: async () => import('@/pages/index/water')
        },
        {
          path: '/materialWarehouseList',
          name: 'materialWarehouseList',
          component: async () => import('@/pages/systemManage/materialWarehouseList')
        },
        {
          path: '/fireControlPlan',
          name: 'fireControlPlan',
          component: async () => import('@/pages/rightBtn/fireControlPlan')
        },
        {
          path: '/xfxc',
          name: 'xfxcIndex',
          component: async () => import('@/pages/xfxc/index')
        },
        {
          path: '/xfxcList',
          name: 'xfxcList',
          component: async () => import('@/pages/xfxc/list')
        },
        {
          path: '/Order12345List',
          name: 'Order12345List',
          component: async () => import('@/pages/Order12345List/index')
        },
        {
          path: '/kh-preview',
          name: 'khPreview',
          component: async () => import('@/pages/gzkh/preview.vue')
        },
        {
          // 体制建设 1
          path: '/kh-tzjs',
          name: 'khTzjs',
          component: async () => import('@/pages/gzkh/tzjs')
        },
        {
          // 宣传动员 2
          path: '/kh-xcdy',
          name: 'khXcdy',
          component: async () => import('@/pages/gzkh/xcdy')
        },
        {
          // 部门考核 3
          path: '/kh-bmkh',
          name: 'khBmkh',
          component: async () => import('@/pages/gzkh/bmkh')
        },
        {
          // 分类投放4
          path: '/kh-fltf',
          name: 'khFltf',
          component: async () => import('@/pages/gzkh/fltf')
        },
        {
          // 收集专业5
          path: '/kh-sjzy',
          name: 'khSjzy',
          component: async () => import('@/pages/gzkh/sjzy')
        },
        {
          path: '/wlwt',
          name: 'wlwt',
          component: async () => import('@/pages/wlwt/index')
        },
        {
          path: '/kh-analysis',
          name: 'khAndlysis',
          component: async () => import('@/pages/wlwt/index-new.vue')
        },
          // 录入 五类问题
        {
          path: '/kh-list',
          name: 'khList',
          component: async () => import('@/pages/gzkh/list')
        },
        {
          path: '/dqyhIndex',
          name: 'dqyhIndex',
          component: async () => import('@/pages/dqyhIndex/red-index.vue')
        },
        {
          path: '/dqyhRecordList',
          name: 'dqyhRecordList',
          component: async () => import('@/pages/dqyhIndex/recordList.vue')
        },
        {
          path: '/ddcjl',
          name: 'ddcjlIndex',
          component: async () => import('@/pages/ddcjl/index.vue')
        },
        {
          path: '/cdh',
          name: 'cdhIndex',
          component: async () => import('@/pages/cdh/index')
        },
        {
          path: '/cdhList',
          name: 'cdhList',
          component: async () => import('@/pages/cdh/List.vue')
        },
        {
          path: '/videoAlarm',
          name: 'videoAlarm',
          component: async () => import('@/pages/videoModule/videoAlarm')
        },
        {
          path: '/videoAlarmList',
          name: 'videoAlarmList',
          component: async () => import('@/pages/videoModule/videoAlarmList')
        },
        {
          path: '/waterlogging',
          name: 'waterloggingIndex',
          component: async () => import('@/pages/waterlogging/index')
        },
        {
          path: '/listSmokeDangersList',
          name: 'listSmokeDangersList',
          component: async () => import('@/pages/smokeDangers/listSmokeDangersList')
        },
        {
          path: '/listSmokeDangers',
          name: 'listSmokeDangers',
          component: async () => import('@/pages/smokeDangers/smokeDangers.vue')
        },
        {
          path: '/ai-inspect-nav',
          name: 'aiInspectNav',
          component: async () => import('@/pages/aiInspectNav/index.vue')
        },
        {
          path: '/ry-inspect-nav',
          name: 'ryInspectNav',
          component: async () => import('@/pages/ryInspectNav/index.vue')
        },
        {
          path: '/people',
          name: 'peopleIndex',
          component: async () => import('@/pages/people/index')
        },
        {
          path: '/homeOtherTable',
          name: 'HomeOtherTable',
          component: async () => import('@/pages/index/HomeOtherTable.vue')
        },
        {
          path: '/videoPatrol',
          name: 'videoPatrol',
          component: async () => import('@/pages/transferView/transferView2')
        },
      ]
    },
    {
      path: '/topMenu',
      name: 'topMenu',
      component: async () => import('@/pages/topMenu/topMenu'),
      children: [
        {
          path: '/homeOtherList',
          name: 'HomeOtherList',
          component: async () => import('@/pages/index/HomeOtherList.vue')
        },
        {
          path: '/homeOtherDeviceList',
          name: 'HomeOtherDeviceList',
          component: async () => import('@/pages/index/HomeOtherDeviceList.vue')
        },
        {
          path: '/callOneOneNineDangers',
          name: 'callOneOneNineDangers',
          component: async () => import('@/pages/oneOneNineDangers/listOneOneNineDangers')
        },
        {
          path: '/smokeDangers',
          name: 'smokeDangers',
          component: async () => import('@/pages/smokeDangers/listSmokeDangers')
        },
        {
          path: '/wgIndex',
          name: 'wgIndex',
          component: async () => import('@/pages/wg/wgIndex')
        },
        {
          path: '/wgIndexlist',
          name: 'wgIndexlist',
          component: async () => import('@/pages/wg/wgIndexlist')
        },
        {
          path: '/electroCarwgyjList',
          name: 'electroCarwgAlarm',
          component: async () => import('@/pages/electroCarwgDangers/electroCarwgAlarm')
        },
        {
          path: '/electroCarwgczList',
          name: 'electroCarwgczAlarm',
          component: async () => import('@/pages/electroCarwgDangers/electroCarwgczAlarm')
        },
        {
          path: '/electroCarwgmdList',
          name: 'electroCarwgmdAlarm',
          component: async () => import('@/pages/electroCarwgDangers/electroCarwgmdAlarm')
        },
        {
          path: '/Pyrotechnicseye',
          name: 'Pyrotechnicseye',
          component: async () => import('@/pages/Pyrotechnicseye/ListPyrotechnicseye')
        },
        {
          path: '/PyrotechnicseyeList',
          name: 'PyrotechnicseyeList',
          component: async () => import('@/pages/Pyrotechnicseye/ListPyrotechnicseyeList')
        },
        {
          path: '/weChatDangers',
          name: 'weChatDangers',
          component: async () => import('@/pages/weChatDangers/listWeChatDangers')
        },
        {
          path: '/broadcast',
          name: 'broadcast',
          component: async () => import('@/pages/broadcast/broadcast')
        },
        {
          path: '/phoneBroadcast',
          name: 'phoneBroadcast',
          component: async () => import('@/pages/broadcast/phoneBroadcast')
        },
        {
          path: '/powerfailure',
          name: 'powerfailure',
          component: async () => import('@/pages/powerfailure/powerfailure')
        },
        {
          path: '/turnoffire',
          name: 'turnoffire',
          component: async () => import('@/pages/turnoffire/turnoffire')
        },
        {
          path: '/callpolice',
          name: 'callpolice',
          component: async () => import('@/pages/callpolice/callpolice')
        },

        {
          path: '/kitchenDangers',
          name: 'kitchenDangers',
          component: async () => import('@/pages/pinkeyeDangers/kitchenDangers')
        },
        {
          path: '/unifyDangers',
          name: 'unifyDangers',
          component: async () => import('@/pages/pinkeyeDangers/unifyDangers')
        },
        {
          path: '/monitorDcDangers',
          name: 'monitorDcDangers',
          component: async () => import('@/pages/monitorDangers/listMonitorDcDangers')
        },
        {
          path: '/rfidDangers',
          name: 'rfidDangers',
          component: async () => import('@/pages/monitorDangers/listRfidDangers')
        },
        {
          path: '/handNewspaperDangers',
          name: 'handNewspaperDangers',
          component: async () => import('@/pages/handNewspaperDangers/HandNewspaperDangers')
        },
        {
          path: '/listHandNewspaperDangers',
          name: 'listHandNewspaperDangers',
          component: async () => import('@/pages/handNewspaperDangers/listHandNewspaperDangers')
        },
        {
          path: '/elevatorDangers',
          name: 'elevatorDangers',
          component: async () => import('@/pages/elevator/elevatorDangers')
        },
        {
          path: '/hiddenDangers',
          name: 'hiddenDangers',
          component: async () => import('@/pages/hiddenDangers/listHiddenDangers')
        },
        {
          path: '/fireWatchChannel',
          name: 'fireWatchChannel',
          component: async () => import('@/pages/handNewspaperDangers/fireWatchChannel')
        },
        {
          path: '/videoAlarmList1',
          name: 'videoAlarmList1',
          component: async () => import('@/pages/videoModule/videoAlarmList1')
        },
        {
          path: '/hjhyIndex',
          name: 'hjhyIndex',
          component: async () => import('@/pages/hjhy/hjhyIndex')
        },
        {
          path: '/homeChargingIndex',
          name: 'homeChargingIndex',
          component: async () => import('@/pages/homeChargingIndex/index')
        },
        {
          path: '/dqyhIndexList',
          name: 'dqyhIndexList',
          component: async () => import('@/pages/dqyhIndex/indexList')
        },
        {
          path: '/carHomeAlarm',
          name: 'carHomeAlarm',
          component: async () => import('@/pages/rightBtn/carHomeAlarm')
        },
        {
          path: '/voiceAlarmList',
          name: 'voiceAlarmList',
          component: async () => import('@/pages/voiceModule/voiceAlarmList')
        },

        {
          path: '/pullDrillDangers',
          name: 'pullDrillDangers',
          component: async () => import('@/pages/pullDrillDangers/listPullDrillDangers')
        },
        {
          path: '/transferView',
          name: 'transferView',
          component: async () => import('@/pages/transferView/transferView')
        },
        {
          path: '/channelSupervision',
          name: 'channelSupervision',
          component: async () => import('@/pages/transferView/transferView3')
        },
        {
          path: '/fireCall',
          name: 'fireCall',
          component: async () => import('@/pages/fireCall/fireCall1')
        },
        {
          path: '/residentList',
          name: 'residentList',
          component: async () => import('@/pages/broadcast/residentList')
        },
        {
          path: '/fireCall1',
          name: 'fireCall1',
          component: async () => import('@/pages/fireCall/fireCall1')
        },
      ]
    },
    {
      path: '/Nav',
      name: 'Nav',
      component: async () => import('@/pages/rightBtn/Nav'),
      children: [
        // {
        //   path: '/index',
        //   name: 'Index',
        //   component: Index
        // },
        {
          path: '/fxlq',
          name: 'fxlq',
          component: async () => import('@/pages/fxlq/List.vue')
        },
        {
          path: '/structOrganize',
          name: 'structOrganize',
          component: async () => import('@/pages/topPage/structOrganize')
        },
        {
          path: '/alarmEquipment',
          name: 'alarmEquipment',
          component: async () => import('@/pages/alarmEquipment/alarmEquipment')
        },
        {
          path: '/onlineUser',
          name: 'onlineUser',
          component: async () => import('@/pages/rightBtn/onlineUser')
        },
        {
          path: '/weCharFire',
          name: 'weCharFire',
          component: async () => import('@/pages/rightBtn/weCharFire')
        },
        {
          path: '/systemManage',
          name: 'systemManage',
          component: async () => import('@/pages/rightBtn/systemManage'),
          children: []
        },
        {
          path: '/manualEquipment',
          name: 'manualEquipment',
          component: async () => import('@/pages/systemManage/manualEquipment')
        },
        {
          path: '/waters',
          name: 'waters',
          component: async () => import('@/pages/index/water')
        },
        {
          path: '/manualEquipment1',
          name: 'manualEquipment1',
          component: async () => import('@/pages/systemManage/manualEquipment1')
        },
        {
          path: '/operateShifts',
          name: 'operateShifts',
          component: async () => import('@/pages/systemManage/operateShifts')
        },
        {
          path: '/hostEquip',
          name: 'hostEquip',
          component: async () => import('@/pages/systemManage/hostEquip')
        },
        {
          path: '/hostDqyh',
          name: 'hostDqyh',
          component: async () => import('@/pages/systemManage/hostDqyh')
        },
        {
          path: '/equipBind',
          name: 'equipBind',
          component: async () => import('@/pages/systemManage/equipBind')
        },
        {
          path: '/smokeEquipment',
          name: 'smokeEquipment',
          component: async () => import('@/pages/systemManage/smokeEquipment')
        },
        {
          path: '/smokeEquipment22',
          name: 'smokeEquipment22',
          component: async () => import('@/pages/systemManage/smokeEquipment22')
        },
        {
          path: '/moduleManage',
          name: 'moduleManage',
          component: async () => import('@/pages/systemManage/moduleManage')
        },
        {
          path: '/aifazhi',
          name: 'aifazhi',
          component: async () => import('@/pages/systemManage/aifazhi')
        },
        {
          path: '/productionBrigade',
          name: 'productionBrigade',
          component: async () => import('@/pages/systemManage/productionBrigade')
        },
        {
          path: '/detachmentEquipment',
          name: 'detachmentEquipment',
          component: async () => import('@/pages/systemManage/detachmentEquipment')
        },
        {
          path: '/element',
          name: 'element',
          component: async () => import('@/pages/systemManage/element')
        },
        {
          path: '/streetEquipment',
          name: 'streetEquipment',
          component: async () => import('@/pages/systemManage/streetEquipment')
        },
        {
          path: '/jyzEquipment',
          name: 'jyzEquipment',
          component: async () => import('@/pages/systemManage/jyzEquipment')
        },
        {
          path: '/departmentManage',
          name: 'departmentManage',
          component: async () => import('@/pages/systemManage/departmentManage')
        },
        {
          path: '/user',
          name: 'user',
          component: async () => import('@/pages/systemManage/user')
        },
        {
          path: '/equipmentInventory',
          name: 'equipmentInventory',
          component: async () => import('@/pages/inventory/equipment')
        },
        {
          path: '/outPutInventory',
          name: 'outPutInventory',
          component: async () => import('@/pages/inventory/outPut')
        },
        {
          path: '/typeInventory',
          name: 'typeInventory',
          component: async () => import('@/pages/inventory/typeManage')
        },
        {
          path: '/partner',
          name: 'partner',
          component: async () => import('@/pages/systemManage/partner')
        },
        {
          path: '/propertyManage',
          name: 'propertyManage',
          component: async () => import('@/pages/systemManage/propertyManage')
        },
        {
          path: '/teamMap',
          name: 'teamMap',
          component: async () => import('@/pages/systemManage/teamMap')
        },
        {
          path: '/moduleServe',
          name: 'moduleServe',
          component: async () => import('@/pages/systemManage/moduleServe')
        },
        {
          path: '/locationDiff',
          name: 'locationDiff',
          component: async () => import('@/pages/systemManage/locationDiff')
        },
        {
          path: '/hydraulic',
          name: 'hydraulic',
          component: async () => import('@/pages/systemManage/hydraulic')
        },
        {
          path: '/smokeEquipment1',
          name: 'smokeEquipment1',
          component: async () => import('@/pages/systemManage/smokeEquipment1')
        },
        {
          path: '/smokeEquipment4g',
          name: 'smokeEquipment4g',
          component: async () => import('@/pages/systemManage/smokeEquipment4g')
        },
        {
          path: '/aiSmokeEquipment',
          name: 'aiSmokeEquipment',
          component: async () => import('@/pages/systemManage/aiSmokeEquipment')
        },
        {
          path: '/wgIot',
          name: 'wgIot',
          component: async () => import('@/pages/systemManage/wgIot')
        },
        {
          path: '/electrocarJsq',
          name: 'electrocarJsq',
          component: async () => import('@/pages/systemManage/electrocarJsq')
        },
        {
          path: '/electrocarWg',
          name: 'electrocarWg',
          component: async () => import('@/pages/systemManage/electrocarWg')
        },
        {
          path: '/equipmentLvc',
          name: 'equipmentLvc',
          component: async () => import('@/pages/systemManage/equipmentLvc')
        },
        {
          path: '/planTask',
          name: 'planTask',
          component: async () => import('@/pages/systemManage/planTask')
        },
        {
          path: '/systemManage2',
          name: 'systemManage2',
          component: async () => import('@/pages/rightBtn/systemManage2')
        },
        {
          path: '/callHistory',
          name: 'callHistory',
          component: async () => import('@/pages/rightBtn/callHistory')
        },
        {
          path: '/jyHistory',
          name: 'jyHistory',
          component: async () => import('@/pages/rightBtn/jyHistory')
        },
        {
          path: '/probeEquip',
          name: 'probeEquip',
          component: async () => import('@/pages/systemManage/probeEquip')
        },
        {
          path: '/probeEquip1',
          name: 'probeEquip1',
          component: async () => import('@/pages/systemManage/probeEquip1')
        },
        {
          path: '/probeEquip2',
          name: 'probeEquip2',
          component: async () => import('@/pages/systemManage/probeEquip2')
        },
        {
          path: '/probeEquip3',
          name: 'probeEquip3',
          component: async () => import('@/pages/systemManage/probeEquip3')
        },
        {
          path: '/probeModelUpgrade',
          name: 'probeModelUpgrade',
          component: async () => import('@/pages/systemManage/probeModelUpgrade')
        },
        {
          path: '/kitchenManagement',
          name: 'kitchen',
          component: async () => import('@/pages/systemManage/kitchen')
        },
        {
          path: '/unifyManagement',
          name: 'unify',
          component: async () => import('@/pages/systemManage/unify')
        },
        {
          path: '/elevatorManagement',
          name: 'elevator',
          component: async () => import('@/pages/systemManage/elevator')
        },
        {
          path: '/breaker',
          name: 'breaker',
          component: async () => import('@/pages/systemManage/breaker')
        },
        {
          path: '/gasroute',
          name: 'gasroute',
          component: async () => import('@/pages/systemManage/gasroute')
        },
        {
          path: '/flamingeye',
          name: 'flamingeye',
          component: async () => import('@/pages/systemManage/flamingeye')
        },
        {
          path: '/hjhy',
          name: 'hjhy',
          component: async () => import('@/pages/hjhy/hjhy')
        },
        {
          path: '/gyfeedwater',
          name: 'gyfeedwater',
          component: async () => import('@/pages/systemManage/gyfeedwater')
        },
        {
          path: '/wzfeedwater',
          name: 'wzfeedwater',
          component: async () => import('@/pages/systemManage/wzfeedwater')
        },
        // {
        //   path: '/lifeDetection',
        //   name: 'lifeDetection',
        //   component: lifeDetection
        // },
        {
          path: '/broadcastManagement',
          name: 'broadcastManagement',
          component: async () => import('@/pages/systemManage/broadcast')
        },
        {
          path: '/audiocallpoliceManagement',
          name: 'audiocallpoliceManagement',
          component: async () => import('@/pages/systemManage/audiocallpolice')
        },
        {
          path: '/callpoliceManagement',
          name: 'callpoliceManagement',
          component: async () => import('@/pages/systemManage/callpolice')
        },
        {
          path: '/materialWarehouse',
          name: 'materialWarehouse',
          component: async () => import('@/pages/systemManage/materialWarehouse')
        },
        {
          path: '/electricCase',
          name: 'electricCase',
          component: async () => import('@/pages/systemManage/electricCase')
        },
        {
          path: '/keyPeople',
          name: 'keyPeople',
          component: async () => import('@/pages/systemManage/keyPeople')
        },
        {
          path: '/systemMc',
          name: 'systemMc',
          component: async () => import('@/pages/systemManage/mc.vue')
        },
        {
          path: '/cdkManage',
          name: 'cdkManage',
          component: async () => import('@/pages/systemManage/cdk')
        },
        {
          path: '/styWaterlogging',
          name: 'styWaterlogging',
          component: async () => import('@/pages/systemManage/waterlogging.vue')
        },
        {
          path: '/thermalCable',
          name: 'thermalCable',
          component: async () => import('@/pages/systemManage/thermalCable.vue')
        },
        {
          path: '/videoAuth',
          name: 'videoAuth',
          component: async () => import('@/pages/systemManage/videoAuth')
        },
        {
          path: '/fctoryManagement',
          name: 'fctoryManagement',
          component: async () => import('@/pages/systemManage/fctoryManagement')
        },
        {
          path: '/acoustoEquip',
          name: 'acoustoEquip',
          component: async () => import('@/pages/systemManage/acoustoEquip')
        },
        {
          path: '/acoustoLLy',
          name: 'acoustoLLy',
          component: async () => import('@/pages/systemManage/acoustoLLy')
        },
        {
          path: '/equiManage',
          name: 'equiManage',
          component: async () => import('@/pages/rightBtn/equiManage')
        },
        {
          path: '/carManage',
          name: 'carManage',
          component: async () => import('@/pages/rightBtn/carManage')
        },
        {
          path: '/carHome',
          name: 'carHome',
          component: async () => import('@/pages/rightBtn/carHome')
        },
        {
          path: '/Charfacilities',
          name: 'Charfacilities',
          component: async () => import('@/pages/rightBtn/Charfacilities')
        },
        {
          path: '/volunteer',
          name: 'volunteer',
          component: async () => import('@/pages/rightBtn/volunteer')
        },
        {
          path: '/callAlarm',
          name: 'callAlarm',
          component: async () => import('@/pages/rightBtn/callAlarm')
        },
        {
          path: '/importanceManage',
          name: 'importanceMan',
          component: async () => import('@/pages/rightBtn/importanceMan')
        },
        {
          path: '/propertyManage',
          name: 'propertyMan',
          component: async () => import('@/pages/rightBtn/propertyMan')
        },
        {
          path: '/personManage',
          name: 'personManage',
          component: async () => import('@/pages/rightBtn/personManage')
        },
        {
          path: '/fileManage',
          name: 'fileManage',
          component: async () => import('@/pages/rightBtn/fileManage')
        },
        {
          path: '/loraEquipment',
          name: 'loraEquipment',
          component: async () => import('@/pages/systemManage/loraEquipment')
        },
        {
          path: '/offEquipment',
          name: 'offEquipment',
          component: async () => import('@/pages/systemManage/offEquipment')
        },
        {
          path: '/polling',
          name: 'polling',
          component: async () => import('@/pages/systemManage/polling')
        },
        {
          path: '/misinformation',
          name: 'misinformation',
          component: async () => import('@/pages/systemManage/misinformation')
        },
        {
          path: '/defenceArea',
          name: 'defenceArea',
          component: async () => import('@/pages/rightBtn/defenceArea')
        },
        {
          path: '/removeCar',
          name: 'removeCar',
          component: async () => import('@/pages/rightBtn/removeCar')
        },
        {
          path: '/department',
          name: 'department',
          component: async () => import('@/pages/rightBtn/department')
        },
        {
          path: '/fireclues',
          name: 'fireclues',
          component: async () => import('@/pages/rightBtn/fireclues')
        },
        {
          path: '/fireWaterSupply',
          name: 'fireWaterSupply',
          component: async () => import('@/pages/rightBtn/fireWaterSupply')
        },
        {
          path: '/announce',
          name: 'announce',
          component: async () => import('@/pages/rightBtn/announce')
        },
        {
          path: '/looklog',
          name: 'looklog',
          component: async () => import('@/pages/rightBtn/looklog')
        },
        {
          path: '/announceDetails/:id',
          name: 'announceDetails',
          component: async () => import('@/pages/rightBtn/announceDetails')
        },
        {
          path: '/equipmentinspection',
          name: 'equipmentinspection',
          component: async () => import('@/pages/rightBtn/equipmentinspection')
        },
        {
          path: '/toAnnounce1',
          name: 'toAnnounce1',
          component: async () => import('@/pages/rightBtn/toAnnounce1')
        },
        {
          path: '/building',
          name: 'building',
          component: async () => import('@/pages/rightBtn/building')
        },
        {
          path: '/operation',
          name: 'operation',
          component: async () => import('@/pages/rightBtn/operation')
        },
        {
          path: '/forTheDuty',
          name: 'forTheDuty',
          component: async () => import('@/pages/rightBtn/forTheDuty')
        }
        //  {
        //   path: '/alarmEquipment',
        //   name: 'alarmEquipment',
        //   component:alarmEquipment
        //  }
      ]
    },
    {
      path: '/microStationMenu',
      name: 'microStationMenu',
      component: async () => import('@/pages/microStation/microStationMenu'),
      children: [
        {
          path: '/microStationHome',
          name: 'microStationHome',
          component: async () => import('@/pages/microStation/microStationHome'),
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.state.styleTp === LJStyleTp && ['/home', 'home-channel'].includes(to.path)) {
    next('/home-ljfl')
    return
  }
  if (store.state.deptStatus === "3" && to.path === '/home') {
    next('/wisdomIndex')
    // next('/home-channel')
  } else {
    next()
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js